import {
  TableActionBarButton,
  TableActionBarRoot,
  TableActionBarRowsSelected,
} from "@/components/shared/data-table/action-bar";
import { useDeleteInvoice } from "@/queries/invoices/delete";
import type { GetAllInvoiceInvoice } from "@/queries/invoices/get-all";
import type { Table } from "@tanstack/react-table";
import { Trash2 } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  table: Table<GetAllInvoiceInvoice>;
};

export const TableActionBar = ({ table }: Props) => {
  const { t } = useTranslation();
  const deleteInvoices = useDeleteInvoice();

  const rows = table.getSelectedRowModel().rows;

  const rowIds = useMemo(() => {
    return rows.map((row) => row.id);
  }, [rows]);

  if (rows.length === 0) return null;

  return (
    <TableActionBarRoot className="gap-4">
      <TableActionBarRowsSelected table={table} />
      <div className="flex gap-2">
        <TableActionBarButton variant="outline" onClick={handleDelete}>
          <Trash2 className="w-4 h-4" />
          {t("delete")}
        </TableActionBarButton>
      </div>
    </TableActionBarRoot>
  );

  function handleDelete() {
    deleteInvoices(rowIds);
  }
};
